import { useMemo } from 'react';
import { useFeatures } from './FeaturesContext';

// Back-compat adapter (plan 041): the module switches now come from the
// feature registry via FeaturesContext. No provider and no fetch of its own —
// useModules() reshapes useFeatures() into the old
// { modules: { benefits, time_off, payroll }, employeeHome, loaded, refresh }.
export function useModules() {
  const { features, employeeHome, loaded, refresh } = useFeatures();
  const { benefits, time_off, payroll } = features;
  return useMemo(() => ({
    modules: { benefits, time_off, payroll },
    employeeHome,
    loaded,
    refresh,
  }), [benefits, time_off, payroll, employeeHome, loaded, refresh]);
}
